
import Cookies from 'js-cookie'
export function getNewCopyDic(dictionary){
    let newDic = {}
    for (let key in dictionary) {
        if (dictionary.hasOwnProperty(key)) { // 确保是对象自有属性，不是原型链上的属性
            Object.assign(newDic,{[key]:dictionary[key]})
        }
    }
    return newDic;
}

export function clearAllCookies() {
    // 获取所有Cookie
    const cookies = Cookies.get();
    
    // 遍历并删除每个Cookie
    for (const cookieName in cookies) {
        if (cookies.hasOwnProperty(cookieName)) {
            Cookies.remove(cookieName);
        }
    }

    // 验证是否所有Cookie都已被清除
    const remainingCookies = Cookies.get();
    console.log('Remaining cookies:', remainingCookies);
    if (Object.keys(remainingCookies).length === 0) {
        console.log('All cookies have been cleared successfully.');
    } else {
        console.log('Some cookies still remain.');
    }
}


export function getGradeArrayByCodeStr(pList,codeStr) {
  // 步骤1：清洗字符串并分割（处理空格、空值、多余逗号）
  const codeList = codeStr
    .trim() // 去除首尾空格
    .split(",") // 按逗号分割
    .map((code) => code.trim()) // 去除每个code的首尾空格（如 "G001, G002" 中的空格）
    .filter((code) => code); // 过滤空字符串（如输入 ",G001," 时，避免空值）

  // 步骤2：无有效code时返回空数组
  if (codeList.length === 0) return [];

  // 步骤3：根据code匹配年级数组
  const result = pList.filter((grade) => codeList.includes(grade.value));

  return result;
}